import { css as e, keyframes as t } from "styled-components";
import { darkColors as n, glassColors as r, lightColors as i, palette as a, radii as o, spacingBase as s, typography as c } from "@maat/ds-palette";
//#region src/theme/theme.ts
var l = (...e) => e.map((e) => `${e * s}px`).join(" "), u = (e) => `${e / 16}rem`, d = {
	palette: a,
	spacing: l,
	typographyTokens: {
		fontFamily: c.fontFamily,
		sizes: {
			xs: u(c.sizes.xs),
			sm: u(c.sizes.sm),
			base: u(c.sizes.base),
			lg: u(c.sizes.lg),
			xl: u(c.sizes.xl),
			"2xl": u(c.sizes["2xl"]),
			"3xl": u(c.sizes["3xl"]),
			"4xl": u(c.sizes["4xl"])
		},
		weights: {
			normal: String(c.weights.normal),
			medium: String(c.weights.medium),
			semibold: String(c.weights.semibold),
			bold: String(c.weights.bold)
		},
		lineHeights: {
			tight: String(c.lineHeights.tight),
			normal: String(c.lineHeights.normal),
			relaxed: String(c.lineHeights.relaxed)
		}
	},
	radii: {
		sm: u(o.sm),
		DEFAULT: u(o.DEFAULT),
		md: u(o.md),
		lg: u(o.lg),
		xl: u(o.xl),
		full: "9999px"
	},
	shadows: {
		none: "none",
		sm: "0 1px 2px rgba(0, 0, 0, 0.05), 0 0 0 1px rgba(28, 27, 31, 0.06)",
		md: "0 4px 14px rgba(0, 0, 0, 0.07), 0 0 0 1px rgba(28, 27, 31, 0.06)",
		lg: "0 8px 24px rgba(173, 47, 60, 0.08), 0 4px 12px rgba(0, 0, 0, 0.06)",
		xl: "0 16px 48px rgba(173, 47, 60, 0.1), 0 8px 16px rgba(0, 0, 0, 0.06)",
		inner: "inset 0 2px 4px 0 rgba(0, 0, 0, 0.06)",
		outline: "0 0 0 3px rgba(173, 47, 60, 0.3)",
		highlight: "inset 0 1px 0 0 rgba(255, 255, 255, 0.1)",
		soft: "0 10px 40px -10px rgba(0, 0, 0, 0.12), 0 0 0 1px rgba(28, 27, 31, 0.06)",
		photo: "0 2px 6px rgba(0, 0, 0, 0.08), 0 8px 20px rgba(0, 0, 0, 0.12)"
	},
	transitions: {
		fast: "150ms ease",
		normal: "250ms ease",
		slow: "350ms ease"
	},
	glass: {
		...r,
		blur: "blur(16px) saturate(180%)",
		shadow: "0 8px 32px 0 rgba(31, 38, 135, 0.07)"
	}
}, f = {
	pillBackground: "rgba(255, 255, 255, 0.85)",
	pillBackgroundStrong: "rgba(255, 255, 255, 0.92)",
	pillBorder: "rgba(28, 27, 31, 0.10)"
}, p = {
	pillBackground: "rgba(61, 58, 63, 0.85)",
	pillBackgroundStrong: "rgba(61, 58, 63, 0.92)",
	pillBorder: "rgba(255, 255, 255, 0.14)"
}, m = {
	...d,
	mode: "light",
	colors: i,
	glass: {
		...d.glass,
		...f
	}
}, h = {
	...d,
	mode: "dark",
	colors: n,
	glass: {
		...d.glass,
		...p
	}
}, g = e`
    background: ${({ theme: e }) => e.glass.pillBackground};
    backdrop-filter: ${({ theme: e }) => e.glass.blur};
    -webkit-backdrop-filter: ${({ theme: e }) => e.glass.blur};
    border: 1px solid ${({ theme: e }) => e.glass.pillBorder};
    box-shadow: ${({ theme: e }) => e.glass.shadow};
`, _ = e`
    background: ${({ theme: e }) => e.glass.pillBackgroundStrong};
    backdrop-filter: ${({ theme: e }) => e.glass.blur};
    -webkit-backdrop-filter: ${({ theme: e }) => e.glass.blur};
    border: 1px solid ${({ theme: e }) => e.glass.pillBorder};
    box-shadow: ${({ theme: e }) => e.glass.shadow};
`, v = e`
    background-color: ${({ theme: e }) => e.colors.card};
    border-radius: ${({ theme: e }) => e.radii.xl};
    box-shadow: ${({ theme: e }) => e.shadows.soft};
`, y = e`
    background-color: rgba(28, 27, 31, 0.25);
    backdrop-filter: blur(8px);
    -webkit-backdrop-filter: blur(8px);
`, b = t`
    0% { background-position: 0% 50%; }
    50% { background-position: 100% 50%; }
    100% { background-position: 0% 50%; }
`, x = {
	bg: e`
        background: linear-gradient(
            110deg,
            #ff4c4c,
            #c06c84,
            #6c5b7b,
            #3b82f6,
            #00d2ff,
            #ff8a00,
            #ff4c4c
        );
        background-size: 300% 300%;
        animation: ${b} 6s ease infinite;
        color: #ffffff;
        border: none;

        &:hover:not(:disabled) {
            opacity: 0.9;
        }
    `,
	border: e`
        position: relative;

        &::before {
            content: '';
            position: absolute;
            inset: 0;
            border-radius: inherit;
            padding: 2px; /* width of the animated border */
            background: linear-gradient(
                110deg,
                #ff4c4c,
                #c06c84,
                #6c5b7b,
                #3b82f6,
                #00d2ff,
                #ff8a00,
                #ff4c4c
            );
            background-size: 300% 300%;
            animation: ${b} 6s ease infinite;
            -webkit-mask:
                linear-gradient(#fff 0 0) content-box,
                linear-gradient(#fff 0 0);
            -webkit-mask-composite: xor;
            mask-composite: exclude;
            pointer-events: none;
        }
    `,
	buttonOutline: e`
        position: relative;
        border-color: transparent !important;
        background: transparent !important;
        color: ${({ theme: e }) => e.colors.foreground} !important;

        &:hover:not(:disabled) {
            background: transparent !important;
        }

        &::before {
            content: '';
            position: absolute;
            inset: 0;
            border-radius: inherit;
            padding: 2px; /* width of the animated border */
            background: linear-gradient(
                110deg,
                #ff4c4c,
                #c06c84,
                #6c5b7b,
                #3b82f6,
                #00d2ff,
                #ff8a00,
                #ff4c4c
            );
            background-size: 300% 300%;
            animation: ${b} 6s ease infinite;
            -webkit-mask:
                linear-gradient(#fff 0 0) content-box,
                linear-gradient(#fff 0 0);
            -webkit-mask-composite: xor;
            mask-composite: exclude;
            pointer-events: none;
        }
    `
};
//#endregion
export { b as aiPulse, x as aiStyles, h as darkTheme, y as glassOverlay, g as glassPill, _ as glassSurface, m as lightTheme, v as raisedSurface, l as spacingFn };
